import { render, staticRenderFns } from "./DocumentTemplateNew.vue?vue&type=template&id=787d1a70&"
import script from "./DocumentTemplateNew.vue?vue&type=script&lang=js&"
export * from "./DocumentTemplateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports